import { type DirectiveBindingValue, handleMessage, handleMessageBeforeLogin } from "./eventTracking";
import { useUserStore } from "@/store/user";
import { ANONYMOUS_ID } from "@/assets/sensors";
import { getMemberStatue } from "@/store/user/utils";
import { useNewUserGuide } from "@/store/newUserGuide";

// 处理埋点事件
export function useEventTracking(data: Omit<DirectiveBindingValue, "uniqueId" | "headers">, ms = 1500) {
  const userStore = useUserStore();
  const newUserGuide = useNewUserGuide();
  const baseEventValue = {
    packageVersion: __PROJECT_VERSION__
  };
  const eventName = data.event;
  const eventValue = {
    ...data.eventValue,
    ...baseEventValue
  };

  console.log('track', eventName, eventValue);

  // b组新手引导：不上报work_prompt相关事件
  if (newUserGuide.isInGuideForB && eventValue.work_prompt) {
    console.warn("b组新手引导：不上报work_prompt相关事件", eventValue);
    // 跳过这次上报
    return false;
  }

  setTimeout(async () => {
    if (userStore.userInfo.token) {
      await handleMessage({
        event: eventName,
        eventValue: eventValue,
        imageAction: data.imageAction,
        uniqueId: userStore.userInfo.uniqueId,
        headers: {
          Token: userStore.userInfo.token,
          "Content-Type": "application/json"
        }
      } as DirectiveBindingValue);
    } else {
      // 未登录时上报埋点
      await handleMessageBeforeLogin(
        {
          event: eventName,
          eventValue: eventValue,
          uniqueId: ANONYMOUS_ID
        },
        {
          "Content-Type": "application/json"
        }
      );
    }
  }, ms);
}

export function getViewName(name: string) {
  switch (name) {
    case "workbench":
      return "view_pino";
    case "modelDetail":
      return "view_model_details";
    case "model-detail":
      return "view_model_details";
    case "templateDetail":
      return "view_template_details";
    case "newTrain":
      return "view_train_edit";
    case "modelCombination":
      return "view_model_combine";
    case "imageDetails":
      return "view_works_share_details";
    case "shareModel":
      return "view_personal_model_share_details";
    case "personalCenter":
      return "view_home";
    default:
      return `view_${name}`;
  }
}

export function handleStartOrEnterEventTracking(event: "$AppStart" | "enter", name?: any) {
  //找不到name抛弃
  if (!name) return;

  // 剔除掉指定路由埋点上报
  if (["workspace", "aiAcademyDetail"].includes(name)) {
    return false;
  }

  let viewValue = getViewName(name);

  const eventValue: Record<string, string | boolean> = {
    view: viewValue
  };

  if (event === "$AppStart") {
    eventValue.$is_first_day = true;
    eventValue.anonymousId = ANONYMOUS_ID;
  } else {
    // enter事件上报用户会员状态
    eventValue.user_member_statue = getMemberStatue();
  }
  useEventTracking({
    event,
    eventValue
  });
}
